export default __webpack_public_path__ + "static/media/cai_card_background.b7df21e2.png";